import * as Utils from "../libraries/utils";

export const gtmEventAddDipBasket = (self) => {
	Utils.pushGTMInternal(
		"AddDipBasket",
		self.product.name,
		self.$route.path,
		"",
		{
			email: (self.$store.getters.personData || {}).email,
			selectedRestaurant: (self.globalSelectedShop || {}).shopName
		}
	);
};